// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rc-autoResize[data-v-0b7b8278]{resize:none;overflow-y:auto;max-height:var(--v1e3ec980);min-height:var(--v0d27c612);scrollbar-width:none}.rc-autoResize[data-v-0b7b8278]::-webkit-scrollbar{display:none}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
